import { render, staticRenderFns } from "./DeliveryAdviceDocumentUpload.vue?vue&type=template&id=3d31a8f6"
import script from "./DeliveryAdviceDocumentUpload.vue?vue&type=script&lang=js"
export * from "./DeliveryAdviceDocumentUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports